import { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { type UserCurrentUserResponseType } from '@/interfaces'
import { useRouter } from 'vue-router'
import { identifyUser } from '@/utils/error-reporter'
import { get } from './helpers'

interface UseCurrentUserResponse {
  isPending: Ref<boolean>
  isError: Ref<boolean>
  data: Ref<UserCurrentUserResponseType | undefined>
  error: Ref<Error | null>
}

export const useCurrentUserQuery = (options?: {
  enabled?: boolean | Ref<boolean>
}): UseCurrentUserResponse => {
  const router = useRouter()
  const enabled = options?.enabled ?? true
  const { isPending, isError, data, error } = useQuery({
    queryKey: ['current_user'],
    queryFn: async () => get(`current_user`, router),
    enabled,
    select: (data) => {
      identifyUser(data.id)
      return data
    }
  })

  return { isPending, isError, data, error }
}
